// extracted by mini-css-extract-plugin
export var Card = "CalculatorModule-module--Card--2-xVn";
export var Disclaimer = "CalculatorModule-module--Disclaimer--1bCtx";
export var Content = "CalculatorModule-module--Content--30xzB";
export var LeftBlock = "CalculatorModule-module--LeftBlock--3yku-";
export var RightBlock = "CalculatorModule-module--RightBlock--1hyj9";
export var Eyebrow = "CalculatorModule-module--Eyebrow--VNe7a";
export var Heading = "CalculatorModule-module--Heading--2kE1r";
export var Fieldset = "CalculatorModule-module--Fieldset--xDPKO";
export var withMargin = "CalculatorModule-module--withMargin--5NhTW";
export var Legend = "CalculatorModule-module--Legend--_Ga0i";
export var Submit = "CalculatorModule-module--Submit--X1QJw";
export var ShortMessage = "CalculatorModule-module--ShortMessage--22Sp1";
export var TimesIcon = "CalculatorModule-module--TimesIcon--B4fpV";
export var CheckIcon = "CalculatorModule-module--CheckIcon--2qHYE";
export var Notice = "CalculatorModule-module--Notice--1hkCw";
export var HasAlert = "CalculatorModule-module--HasAlert--G1JiJ";
export var Results = "CalculatorModule-module--Results--1QKvV";
export var ResultsHeading = "CalculatorModule-module--ResultsHeading--33WUI";
export var ResultsTableOverflow = "CalculatorModule-module--ResultsTableOverflow--1VDU2";
export var ResultsTable = "CalculatorModule-module--ResultsTable--22uLH";
export var ResultsTableLeft = "CalculatorModule-module--ResultsTableLeft--3c97b";
export var ResultsTableRight = "CalculatorModule-module--ResultsTableRight--11-if";
export var ResultsTableCenter = "CalculatorModule-module--ResultsTableCenter--3knWf";
export var ResultsTableHeader = "CalculatorModule-module--ResultsTableHeader--27N1D";
export var ResultsTableTotalLine = "CalculatorModule-module--ResultsTableTotalLine--3tP7g";
export var ExampleText = "CalculatorModule-module--ExampleText--1cuoT";